import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import Formatter from '../Formatter';
import { StatoOperazione } from './SnackbarUtils';
import DownIcon from '../Icons/DownIcon';
import UpIcon from '../Icons/UpIcon';
import Badge from '../Badge';
import Progress from '../Progress';
import Table from '../Table';
import Button from '../Button';

class DettaglioOperazioneMassiva extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showErrors: false,
    };
  }

  onErroriExpanded = () => {
    const { segnaErroriOperazioneChecked, operazione } = this.props;

    this.setState((prevState) => ({
      showErrors: !prevState.showErrors,
    }), () => segnaErroriOperazioneChecked(operazione.id));
  };

  onErroriCollapsed = () => {
    this.setState((prevState) => ({
      showErrors: !prevState.showErrors,
    }));
  };

  handleFeedback = (e) => {
    const { eliminaOperazioneAsync, onFeedback, operazione } = this.props;

    eliminaOperazioneAsync && eliminaOperazioneAsync(operazione.id);
    onFeedback && onFeedback(e, operazione.id, operazione);
  };

  stampaInfo = (operazione) => {
    const { errori } = operazione;
    const { showErrors } = this.state;
    return (
      <div className="snackbar__infoWrapper">
        <div className="snackbar__timeStamp">
          <Formatter
            tipo="date"
            valore={operazione.timeStamp}
          />
          -
          <Formatter
            tipo="hour"
            valore={operazione.timeStamp}
          />
        </div>
        {operazione.stato === StatoOperazione.COMPLETED && operazione.checked && (
          <div className="snackbar__infoResults">
            <span>
              Selezionati:
              <strong>{operazione.selezionati}</strong>
            </span>
            <span>
              Elaborati:
              <strong>{operazione.elaborati}</strong>
            </span>
          </div>
        )}
        {operazione.stato === StatoOperazione.COMPLETED
          && errori.length > 0
          && (showErrors
            ? <UpIcon onClick={this.onErroriCollapsed} />
            : <DownIcon onClick={this.onErroriExpanded} />
          )}
        {operazione.stato === StatoOperazione.COMPLETED
          && errori.filter((x) => !x.deleted).length > 0
          && <Badge alarm>{operazione.errori.filter((x) => !x.deleted).length}</Badge>}
        {operazione.stato === StatoOperazione.COMPLETED
          && (errori.length === 0 || operazione.testoFeedback)
          && (
            <Button
              className="snackBar__okNoErrorBtn"
              onClick={this.handleFeedback}
              text
            >
              {operazione.testoFeedback || 'OK'}
            </Button>
          )}
        {operazione.stato === StatoOperazione.PENDING && (
          <Progress
            indeterminate={operazione.selezionati == null}
            percentage={operazione.progresso}
          />
        )}
        {operazione.stato === StatoOperazione.PENDING
          && errori.length > 0
          && (showErrors
            ? <UpIcon onClick={this.onErroriCollapsed} />
            : <DownIcon onClick={this.onErroriExpanded} />
          )}
        {operazione.stato === StatoOperazione.PENDING
          && errori.length > 0 && <Badge alarm>{errori.length}</Badge>}
        <div className="clear" />
      </div>
    );
  };

  getErrori = (operazione) => operazione.errori.filter((x) => !x.deleted);

  render() {
    const {
      aggiornaStatoErrore,
      eliminaOperazioneAsync,
      operazione,
    } = this.props;
    const {
      showErrors,
    } = this.state;
    const errori = this.getErrori(operazione);
    return (
      <div className="snackbar__dettaglioOperazioneMassiva">
        <div className="snackbar__infoContainer">
          {this.stampaInfo(operazione)}
        </div>

        <TransitionGroup className="snackbar__containerTabellaErrori">
          {showErrors && (
            <CSSTransition
              component="div"
              timeout={250}
              classNames="snackbar__errori"
            >
              <Table className="snackbar__tabellaErrori">
                <Table.Head>
                  <tr>
                    <th style={{ width: '90%' }}>Errore</th>
                    {operazione.stato === StatoOperazione.COMPLETED && (
                      <th style={{ width: '10%' }}>
                        <Button
                          onClick={() => eliminaOperazioneAsync(operazione.id)}
                          text
                        >
                          Pulisci
                        </Button>
                      </th>
                    )}
                  </tr>
                </Table.Head>
                <Table.Body>
                  {errori.map((e, i) => (/* eslint-disable react/no-array-index-key */
                    <tr key={i}>
                      <td>{e.content || e.message}</td>
                      {operazione.stato === StatoOperazione.COMPLETED && (
                        <td className="snackbar__actions">
                          <Button
                            onClick={() => aggiornaStatoErrore(
                              operazione.id, e.id, operazione.stato === StatoOperazione.COMPLETED,
                            )}
                            text
                          >
                            OK
                          </Button>
                          {e.actions}
                        </td>
                      )}
                    </tr>
                  ) /* eslint-enable */)}
                </Table.Body>
              </Table>
            </CSSTransition>
          )}
        </TransitionGroup>
      </div>
    );
  }
}

DettaglioOperazioneMassiva.propTypes = {
  aggiornaStatoErrore: PropTypes.func,
  eliminaOperazioneAsync: PropTypes.func,
  onFeedback: PropTypes.func,
  operazione: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  segnaErroriOperazioneChecked: PropTypes.func,
};

DettaglioOperazioneMassiva.defaultProps = {
  aggiornaStatoErrore: null,
  eliminaOperazioneAsync: null,
  onFeedback: null,
  operazione: null,
  segnaErroriOperazioneChecked: null,
};

export default DettaglioOperazioneMassiva;
